import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface IAccessCode {
  code: string;
  password: string;
  clinicalPharmacyId: string;
}

type State = {
  accessCode: IAccessCode | null;
};

type Actions = {
  addAccessCode: (accessCode: IAccessCode) => void;
  clearAccessCode: () => void;
};

export const useNotificationStore = create(
  immer<State & Actions>((set) => ({
    accessCode: null,
    addAccessCode: (accessCode: IAccessCode) => set(() => ({ accessCode: accessCode })),
    clearAccessCode: () => set({ accessCode: null }),
  })),
);
